import { api } from '../config/api'
import { CHECK_LASTED } from './actionTypes'

export const checkLasted = () => (dispatch, getState) => {
  const { lang } = getState()
  dispatch({ type: CHECK_LASTED.REQUEST })
  return (
    fetch(api.checkLasted)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: CHECK_LASTED.SUCCESS, data: res[0] })
    })
    .catch((err) => {
      dispatch({ type: CHECK_LASTED.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/actions/checkLasted.js